import { Role } from '../types'

const hasRole = (required: string[], usersRoles: Role[] | undefined) => {
  if (usersRoles === undefined) return false
  const userRoleNames = usersRoles.map(role => role.name)
  return userRoleNames.some(roleName => required.includes(roleName))
}

export default hasRole
